import React, { useState, useEffect } from "react";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { Grid } from "@mui/material";
import ListOfOpenJobs from "../../components/ListOfOpenJobs/ListOfOpenJobs";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import MoodBadIcon from "@mui/icons-material/MoodBad";
import Card from "../../uicomponents/Card";
import API from "../../utils/Axios.utils";
import CustomModel from "../../utils/CustomModel";
import AwardedDetails from "./AwardedDetails";
import HoldProfilesDetails from "./HoldProfilesDetails";
import OpportunityLostDetails from "./OpportunityLostDetails";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import InterviewProfilesDetails from "./InterviewProfilesDetails";
import useAuth from "../../hooks/useAuth";

const SupplierDashboard = () => {
  const [openJob, setOpenJob] = useState("");
  const [onHoldJob, setOnHoldJob] = useState("");
  const [oppLost, setOppLost] = useState(0);
  const [awarded, setAwarded] = useState(0);

  const [openAwardedModal, setOpenAwardedModal] = useState(false);
  const [openHoldModal, setOpenHoldModal] = useState(false);
  const [openOppLostModal, setOpenOppLostModal] = useState(false);

  const handleAwardedOpen = () => setOpenAwardedModal(true);
  const handleAwardedClose = () => setOpenAwardedModal(false);

  const handleHoldOpen = () => setOpenHoldModal(true);
  const handleHoldClose = () => setOpenHoldModal(false);

  const handleOppLostOpen = () => setOpenOppLostModal(true);
  const handleOppLostClose = () => setOpenOppLostModal(false);

  const [interviewCount, setInterviewCount] = useState(0);
  const [openInterviewModal, setOpenInterviewModal] = useState(false);

  const handleInterviewOpen = () => setOpenInterviewModal(true);
  const handleInterviewClose = () => setOpenInterviewModal(false);

  const { token, userId: userID, supplierId } = useAuth();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getJobOpen = async () => {
    const url = `/api/dash/openjoblist_supplier?supplierId=${supplierId}`;

    try {
      const res = await API.get(url, config);
      setOpenJob(res?.data?.open_job_count_supplier);
    } catch (error) {
      console.log(error);
    }
  };

  const getJobOnhold = async () => {
    try {
      const res = await API.get(`/api/dash/holdjob_supplier/${userID}`, config);
      setOnHoldJob(res?.data?.hold_job_count);
    } catch (error) {
      console.log(error);
    }
  };
  const getOppLost = async () => {
    try {
      const res = await API.get(`/api/dash/opportunitylost/${userID}`, config);
      setOppLost(res?.data?.opportunity_lost_count);
    } catch (error) {
      console.log(error);
    }
  };
  const getAwarded = async () => {
    try {
      const res = await API.get(`/api/dash/awardedjob/${userID}`, config);
      setAwarded(res?.data?.awarded_job_count);
    } catch (error) {
      console.log(error);
    }
  };

  const getInterviewCount = async () => {
    try {
      const res = await API.get(
        `/api/dash/interview-profiles/${userID}`,
        config
      );
      setInterviewCount(res?.data?.interview_profiles_count || 0);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getJobOnhold();
    getOppLost();
    getAwarded();
    getJobOpen();
    getInterviewCount();
  }, []);

  // useEffect(() => {
  //   getOppLost();
  // }, []);

  // useEffect(() => {
  //   getAwarded();
  // }, []);

  // useEffect(() => {
  //   getJobOpen();
  // }, []);

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <Grid container spacing={2}>
          {/* Card 1 */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              text="New Jobs"
              number={openJob}
              icon={<BusinessCenterIcon sx={{ fontSize: "50px" }} />}
            />
          </Grid>
          {/* Card 2 */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              text="Awarded"
              number={awarded}
              icon={<EmojiEventsIcon sx={{ fontSize: "50px" }} />}
              onClick={handleAwardedOpen}
            />
          </Grid>
          {/* Card 3 */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              text="On-hold"
              number={onHoldJob}
              icon={<PauseCircleIcon sx={{ fontSize: "50px" }} />}
              onClick={handleHoldOpen}
            />
          </Grid>
          {/* Card 4 */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              text="Opportunity Lost"
              number={oppLost}
              icon={<MoodBadIcon sx={{ fontSize: "50px" }} />}
              onClick={handleOppLostOpen}
            />
          </Grid>
          {/* Card 5 – Interviews Track */}
          <Grid item xs={12} sm={6} md={2.4}>
            <Card
              text="Interviews Tracking"
              number={interviewCount}
              icon={<RecordVoiceOverIcon sx={{ fontSize: "50px" }} />}
              onClick={handleInterviewOpen}
            />
          </Grid>
        </Grid>

        <div style={{ marginTop: "20px" }}>
          <ListOfOpenJobs supplier="supplier" />
        </div>
      </div>
      <CustomModel
        open={openAwardedModal}
        handleDialog={handleAwardedClose}
        title="Awarded Profiles"
        width="lg"
      >
        <AwardedDetails handleDialog={handleAwardedClose} />
      </CustomModel>
      {/* On-hold profiles modal */}
      <CustomModel
        open={openHoldModal}
        handleDialog={handleHoldClose}
        title="On-hold Profiles"
        width="lg"
      >
        <HoldProfilesDetails handleDialog={handleHoldClose} />
      </CustomModel>
      {/* Opportunity lost modal  */}
      <CustomModel
        open={openOppLostModal}
        handleDialog={handleOppLostClose}
        title="Opportunity Lost Profiles"
        width="lg"
      >

        <OpportunityLostDetails handleDialog={handleOppLostClose} />
      </CustomModel>

      <CustomModel
        open={openInterviewModal}
        handleDialog={handleInterviewClose}
        title="Interview Profiles"
        width="lg"
      >
        <InterviewProfilesDetails handleDialog={handleInterviewClose} />
      </CustomModel>
    </>
  );
};

export default SupplierDashboard;
